export default __webpack_public_path__ + "static/media/White0007.65b54f18.png";